export default function isInteger(value) {
  return Number.isInteger(Number.parseInt(value));
}
